import { Copy, ExternalLink, Link2, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { gymLoginUrl } from "../lib/gymAddress";

// The gym's web address (lib/gymAddress.js), where its staff and members sign in, with copy and open buttons.
export function GymWebAddress({ address }) {
  const url = gymLoginUrl(address);
  const copy = () => {
    navigator.clipboard.writeText(url);
    toast.success("Address copied!");
  };
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 flex items-center gap-2 h-10 rounded-sm border border-input bg-secondary px-3 overflow-hidden">
        <Link2 className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
        <span className="truncate text-xs font-mono" data-testid="gym-web-address">{url}</span>
      </div>
      <Button variant="outline" size="icon" className="h-10 w-10 rounded-sm shrink-0" onClick={copy} aria-label="Copy address">
        <Copy className="h-4 w-4" />
      </Button>
      <Button variant="outline" size="icon" className="h-10 w-10 rounded-sm shrink-0" asChild>
        <a href={url} target="_blank" rel="noopener noreferrer" aria-label="Open address"><ExternalLink className="h-4 w-4" /></a>
      </Button>
    </div>
  );
}

// Shown on the dashboard right after signup: the new gym's web address, to share with its staff and members.
export function GymWelcomeCard({ address, onDismiss }) {
  if (!address) return null;
  return (
    <Card className="bg-card border-primary/40 rounded-sm" data-testid="gym-welcome-card">
      <CardContent className="pt-5 space-y-3">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="font-semibold">Your gym is ready</p>
            <p className="text-sm text-muted-foreground">
              Your staff and members sign in at this address. You can find it again under Settings.
            </p>
          </div>
          <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={onDismiss} aria-label="Dismiss">
            <X className="h-4 w-4" />
          </Button>
        </div>
        <GymWebAddress address={address} />
      </CardContent>
    </Card>
  );
}
